
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stemmen",
      function () {
        return require("private-next-pages/stemmen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stemmen"])
      });
    }
  